function formatDate(value) {
  if (!value) {
    return "—";
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short"
  }).format(new Date(value));
}

function formatDateOnly(value) {
  if (!value) {
    return "—";
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium"
  }).format(new Date(value));
}

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function formatNumber(value, options = {}) {
  const parsed = toNumber(value);
  if (parsed === null) {
    return "—";
  }

  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options
  }).format(parsed);
}

// Grouped digits for a whole number that has to be read at a glance — a
// seven-figure token count is unreadable without them ("1,012,020", not
// "1012020"). Pinned to en-US rather than the browser locale so the rendered
// string is identical everywhere (this UI is English, and specs assert on it).
// A missing value is an em dash, never a fabricated 0 — callers that mean "none
// yet, count from zero" pass `value ?? 0` themselves.
function groupDigits(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed.toLocaleString("en-US") : "—";
}

function todayIsoDate() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}

export { formatDate, formatDateOnly, toNumber, formatNumber, groupDigits, todayIsoDate };
